import { TextField as MuiTextField, TextFieldProps } from '@mui/material';

const TextField = (props: TextFieldProps) => <MuiTextField {...props} />;

export default TextField;
